<!-- eslint-disable -->
<template lang="pug">
    .app-container
        .app-container__background
            .app-container__header
                app-header(
                    @toggleSidebar="sidebar = !sidebar"
                    :is-menu-button-displayed="isSidebarDisplayed"
                )
            .app-container__body
                .sidebar-column(
                    :class="{'sidebar-column--opened': sidebar}"
                    v-if="isSidebarDisplayed"
                )
                    sidebar(
                        @toggleSidebar="sidebar = !sidebar",
                        :is-open="sidebar",
                        :in-games="inGames"
                    )
                .main-column--blur(v-show="sidebar && isSidebarDisplayed")
                .main-column(
                    :class="{\
                            'main-column--without-sidebar': !isSidebarDisplayed,\
                            'main-column--gray-bg': isGrayBackground,\
                            'main-column--relative': isBattle,\
                            'main-column--without-offset': isBattleResult\
                    }"
                )
                    router-view(v-if="$offline || user")
                    cs-loader(v-else)
            pay-popup(
                v-if="false"
                @close="handleCloseOfPayPopup"
                :profile="payProfile"
                :need-to-pay="difference"
                :user="user"
            )
            notification-popup(
                v-if="false"
                @close="handleCloseOfNotificationPopup"
            )
            school-prolongation-activity-popup(
                v-if="showSchoolProlongationActivityPopup"
                @close="handleCloseOfSchoolProlongationActivityPopup"
                @redirect="redirecToSchoolPage"
            )
            battle-reconnect(v-if="isBattlePaused && isNeedToShowResumeBlock")
            battle-invitation(v-if="isNeedToShowBattleInvitationBlock")
</template>

<script>
    /*eslint-disable*/
    import AppHeader from './AppHeader.vue';
    import Sidebar from './Sidebar.vue';
    import PayPopup from '../../components/popups/PayPopup.vue';
    import NotificationPopup from '../../components/popups/NotificationPopup.vue';
    import BattleInvitation from '../../components/mental-battle/Invitation.vue';
    import BattleReconnect from '../../components/mental-battle/BattleReconnect.vue';
    import MobileDetect from 'mobile-detect/mobile-detect.js';
    import Hammer from 'hammerjs';

    import { mapState } from 'vuex';
    import UserApi from '../../api/user/user';
    import BattleApi from '../../api/battle';
    import SchoolProlongationActivityPopup from '../../components/popups/SchoolProlongationActivityPopup.vue';
    import SchoolApi from '@/api/school';

    export default {
        components: {
            Sidebar,
            AppHeader,
            PayPopup,
            NotificationPopup,
            SchoolProlongationActivityPopup,
            BattleInvitation,
            BattleReconnect,
        },
        watch: {
            $route(newRoute, oldRoute) {
                if (newRoute.name === 'browse:game' || newRoute.name.includes(':start') || newRoute.name === 'abacus') {
                    this.inGames = true;
                    this.sidebar = false;
                } else if (
                    (oldRoute.name.includes(':start') && newRoute.name !== 'browse:game') ||
                    ((oldRoute.name === 'browse:game' || oldRoute.name === 'abacus') &&
                        !newRoute.name.includes(':start'))
                ) {
                    this.inGames = false;
                }
                if (newRoute.name.includes('trainer')) {
                    clearTimeout(this.payPopupTimerId);
                }
            },
            '$store.state.auth.user' () {
                BattleApi.getReconnectStatus()
                    .then(data => {
                        if (data.isBattlePaused) {
                            this.isNeedToShowResumeBlock = true;
                        }
                    });
            },
            '$store.state.battle.isBattlePaused' () {
                if (this.isBattlePaused) {
                    this.isNeedToShowResumeBlock = true;
                }
            },
        },
        data() {
            return {
                isMobile: false,
                payProfiles: [],
                differences: [],
                showPayPopup: false,
                showSchoolProlongationActivityPopup: false,
                showNotificationPopup: true,
                inGames: false,
                payPopupTimerId: null,
                isNeedToShowResumeBlock: null,
                remainingDays: 0,
                monthPayment: { sum: 0, courses: [], isStock: false, isSubscription: false },
                dayOfMonth: null,
                needToPay: null,
            };
        },
        created() {
            let mobileDetector = new MobileDetect(window.navigator.userAgent);
            this.isMobile = Boolean(mobileDetector.phone() || mobileDetector.mobile());
            this.sidebar = this.$currentViewport.label !== 'mobile' && this.$currentViewport.label !== 'table';
        },
        mounted() {
            this.getRemainingDays();
            this.getSchoolData();
            if (!this.$offline) {
                this.addSidebarBehavior();
                this.getReconnectStatus();
                if (!this.$route.name.includes('trainer')) {
                    this.payPopupTimerId = setTimeout(() => this.getUserAccountsInfo(), 5 * 1000);
                }
            }
            const isChecked = localStorage.getItem('notificationPopupChecked_v2');
            if (isChecked !== null && isChecked) {
                this.showNotificationPopup = false;
            }
        },
        beforeDestroy() {
            clearTimeout(this.payPopupTimerId);
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                battleInvitation: state => state.battle.invitation,
                isBattlePaused: state => state.battle.isBattlePaused,
                selectedCourse: state => state.trainer.course,
            }),
            sidebar: {
                get() {
                    return this.$store.state.isShowSidebar;
                },
                set(value) {
                    this.$store.state.isShowSidebar = value;
                },
            },
            isMentalArithmeticCourse() {
                return this.selectedCourse === 'mentalArithmetic' || this.user.pointsAccesses.includes('mentalArithmetic');
            },
            isSidebarDisplayed() {
                return this.$route.name !== 'select-course' && !this.inGames;
            },
            payProfile() {
                return this.payProfiles[0];
            },
            difference() {
                return this.differences[0];
            },
            isGrayBackground() {
                const startRoutesWithoutGrayBackground = ['olympiads:start'];
                return (
                    !startRoutesWithoutGrayBackground.includes(this.$route.name) &&
                    (this.$route.name.includes(':start') || this.$route.name === 'abacus')
                );
            },
            isBattle() {
                return this.$route.name === 'battle:start';
            },
            isBattleResult() {
                return this.$route.name === 'battle:result';
            },
            isNeedToShowBattleInvitationBlock() {
                return this.battleInvitation?.userId && this.battleInvitation?.userId === this.user.id;
            },
        },
        methods: {
            getCurrentDayOfMonth() {
                const today = new Date();
                return today.getDate();
            },
            getSumToActivateSchool() {
                return Math.round((this.monthPayment.sum - this.user.school.account.balance) * 100) / 100;
            },
            isProlongationPopupNeeded() {
                this.dayOfMonth = this.getCurrentDayOfMonth();
                this.needToPay = this.getSumToActivateSchool();

                let activationData = JSON.parse(localStorage.getItem('schoolActivationPopupChecked'));
                if (this.user.type === 'teacher' || this.user.type ==='admin') {
                    if (this.needToPay <= 0) {
                        this.showSchoolProlongationActivityPopup = false;
                        return;
                    }
                    if (!this.user.school.isBillingActive) {
                        this.showSchoolProlongationActivityPopup = false;
                        return;
                    }
                    if (!activationData) {
                        this.showSchoolProlongationActivityPopup = true;
                        return;
                    }
                    if (activationData && this.remainingDays <= 7 &&
                        (this.needToPay !== activationData.sum || activationData.day !== this.dayOfMonth)
                    ) {
                        this.showSchoolProlongationActivityPopup = true;
                        return;
                    }
                }
            },
            getRemainingDays() {
                const currentDate = new Date();
                const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
                const millisecondsPerDay = 24 * 60 * 60 * 1000;
                this.remainingDays = Math.ceil((lastDayOfMonth - currentDate) / millisecondsPerDay);
            },
            async getSchoolData() {
                let data = await SchoolApi.getSummary(this.user.school.id);
                this.monthPayment = data.monthPayment;
                this.isProlongationPopupNeeded();
            },
            getUserAccountsInfo() {
                UserApi.getUserAccountsInfo()
                    .then(data => {
                        if (this.user.type === 'admin' && Object.keys(data.schoolsAccountsToBeBlocked).length) {
                            Object.keys(data.schoolsAccountsToBeBlocked).forEach(blockedSchoolId => {
                                if (data.schoolsAccountsToBeBlocked[blockedSchoolId]) {
                                    this.payProfiles.push(
                                        this.user.schools.find(school => school.id === +blockedSchoolId)
                                    );
                                    this.differences.push(data.schoolsAccountsToBeBlocked[blockedSchoolId]);
                                }
                            });
                        }
                        if (
                            this.user.type === 'student' &&
                            this.user.schools.some(school => school.studentPayed) &&
                            data.isAccountBlocked
                        ) {
                            this.payProfiles.push(this.user);
                            this.differences.push(data.isAccountBlocked);
                        }
                        this.differences.length && (this.showPayPopup = data.showPopup);
                    })
                    .catch(err => {
                        if (err.status && err.status === 503) {
                            this.$toasted.error(err.message);
                        }
                    });
            },
            handleCloseOfPayPopup() {
                this.showPayPopup = false;
                this.payProfiles.splice(0, 1);
                this.differences.splice(0, 1);
                this.differences.length && (this.showPayPopup = true);
            },
            handleCloseOfNotificationPopup(val) {
                this.showNotificationPopup = false;
                if (val) {
                    localStorage.setItem('notificationPopupChecked_v2', val);
                }
            },
            handleCloseOfSchoolProlongationActivityPopup() {
                this.showSchoolProlongationActivityPopup = false;
                localStorage.setItem('schoolActivationPopupChecked', JSON.stringify({
                    sum: this.needToPay,
                    day: this.dayOfMonth
                }));
            },
            redirecToSchoolPage() {
                this.handleCloseOfSchoolProlongationActivityPopup();
                this.$router.push({name: 'school:profile',  params: {id: this.user.school.id}})
            },
            addSidebarBehavior() {
                let sidebar = document.getElementsByClassName('app-sidebar')[0];
                if (sidebar) {
                    this.addHorizontalSwipeEventListenerToElement(sidebar);
                }
                if (this.isMobile) {
                    let mainContent = document.getElementsByClassName('main-column--blur')[0];
                    this.addClickAwayEventListenerToElement(mainContent);
                }
            },
            addHorizontalSwipeEventListenerToElement(element) {
                let mc = new Hammer.Manager(element);
                let Swipe = new Hammer.Swipe({
                    event: 'swipe',
                    pointers: 1,
                    threshold: 5,
                    direction: Hammer.DIRECTION_HORIZONTAL,
                    velocity: 0.2,
                });
                mc.add(Swipe);
                mc.on('swipe', () => {
                    this.sidebar = !this.sidebar;
                });
            },
            addClickAwayEventListenerToElement(element) {
                let mc = new Hammer.Manager(element);
                let Tap = new Hammer.Tap({
                    taps: 1,
                });
                mc.add(Tap);
                mc.on('tap', () => {
                    this.sidebar = false;
                });
            },
            getReconnectStatus() {
                BattleApi.getReconnectStatus()
                    .then(data => {
                        if (data.isBattlePaused !== null) {
                            this.$store.dispatch('setBattlePaused', data.isBattlePaused);
                        }
                    })
                    .catch(err => {
                        if (err.status && err.status === 503) {
                            this.$toasted.error(err.message);
                        }
                    });
            },
        },
    };
</script>

<style scoped lang="scss">
    .app-container {
        display: flex;
        align-items: stretch;
        flex-direction: column;
        min-height: 100vh;
        background: $hsl-color-green-58;
    }

    .app-container__background {
        flex-shrink: 0;
        flex-grow: 1;
        display: flex;
        align-items: stretch;
        flex-direction: column;
        background: url('../../assets/images/background.svg');
        background-size: cover;
    }

    .app-container__header {
        padding: 0 10px;
        flex-grow: 0;
        flex-shrink: 0;
        @include media($sm) {
            padding: 0 30px;
        }
        @include media($md) {
            padding: 0 30px 0 40px;
        }
    }

    .app-container__body {
        display: flex;
        flex: 1 0 auto;
        @include media($sm) {
            padding-bottom: 30px;
        }
    }

    .sidebar-column {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        z-index: 11;
        max-height: 100%;
        position: fixed;
        top: 0;
        background-color: $hsl-color-green-58;
        width: 320px;
        transition: width 200ms ease-in-out;
        box-sizing: border-box;
        @include media($sm) {
            width: 350px;
        }
        @include media($xlg) {
            position: static;
            height: auto;
            background-color: transparent;
            margin-right: 48px;
            width: $sidebar-open-width;
        }
        &--opened {
            height: 100%;
            @include media($xlg) {
                height: auto;
            }
        }
        &:not(.sidebar-column--opened) {
            width: 0;
            @include media($md) {
                position: static;
                height: auto;
                margin-right: 30px;
                background-color: transparent;
                width: $sidebar-close-width;
            }
        }
    }

    .main-column {
        overflow-x: hidden;
        width: 100%;
        box-sizing: border-box;
        padding: 30px 20px;
        background-color: $x-color-white;
        @include media($sm) {
            background-color: transparent;
            padding: 0 30px;
        }
        @include media($md) {
            padding: 0 30px 0 0;
        }
    }

    .is-fullscreen {
        padding: 0;
    }

    .main-column--gray-bg {
        background-color: $hsl-color-gray-98;
        @include media($sm) {
            background-color: transparent;
        }
    }

    .main-column--relative {
        @media screen and (max-width: 575px) {
            position: relative;
        }
    }

    .main-column--without-sidebar {
        @include media($sm) {
            padding: 0 30px;
        }
    }

    .main-column--without-offset {
        @media screen and (max-width: 575px) {
            padding: 0;
        }
    }

    .main-column--blur {
        z-index: 10;
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        right: 0;
        background: rgba($x-color-black, $opacity-blur-modal-background);
        backdrop-filter: blur($blur-default-sidebar-background);
        @include media($xlg) {
            display: none;
        }
    }
</style>
